import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  UPDATE_READY_EVENT,
  applyUpdate,
  initUpdateWatch,
} from '../../services/update';

// Тост «Доступно обновление» (barter-025): новый SW уже активирован в фоне,
// но страница продолжает работать старым кодом — перезагружаемся только по
// кнопке пользователя. Данные (Dexie, localStorage) и текущий URL перезагрузку
// переживают, так что состояние пользователя не сбрасывается.

export function UpdateToast() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initUpdateWatch(); // слушатель controllerchange + периодическая проверка
    const onReady = () => setVisible(true);
    window.addEventListener(UPDATE_READY_EVENT, onReady);
    return () => window.removeEventListener(UPDATE_READY_EVENT, onReady);
  }, []);

  if (!visible) return null;
  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span className="update-toast__text">
        <span className="update-toast__icon">⬇️</span> {t('update.available')}
      </span>
      <div className="update-toast__actions">
        <button type="button" className="update-toast__later" onClick={() => setVisible(false)}>
          {t('update.later')}
        </button>
        <button type="button" className="btn btn--primary update-toast__apply" onClick={() => applyUpdate()}>
          {t('update.apply')}
        </button>
      </div>
    </div>
  );
}
